import store from '@/store';
import transactionStore from '../store/index';

export function registerStore() {
  store.registerModule('transaction', transactionStore, {
    preserveState: !!store.state['transaction'],
  });
}

export default function init() {
  //do initial work
  registerStore();
}
